import React from 'react';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';

import { makeStyles } from '@material-ui/core/styles';
import { preface } from './__data';

const useStyles = makeStyles((theme) => ({
  paper: {
    height: '100%',
    padding: theme.spacing(4),
    background: 'transparent',
  },
  section: {
    padding: '5rem 0',
  }
}));

const Preface = () => {
  const classes = useStyles();

  return (
    <>
      <Grid
        className={classes.section}
        component="article"
        container
      >
        <Grid
          item
          md={6}
          xs={12}
        >
          <Paper
            className={classes.paper}
            elevation={0}
          >
            <CardMedia
              alt={preface.title}
              component="img"
              image={preface.img}
              object-fit
              title={preface.title}
            />
          </Paper>
        </Grid>
        <Grid
          item
          md={6}
          xs={12}
        >
          <Paper
            className={classes.paper}
            container
            direction="column"
            elevation={0}
          >
            <Grid
              alignContent="center"
              alignItems="center"
              container
              style={{height:'100%'}}
              wrap	
            >
              <Grid
                item
              >
                <Box>
                  <Typography
                    color="primary"
                    component="h3"
                    variant="h4"
                  >
                    Partez en exploration
                  </Typography>
                  <Typography
                    component="p"
                    variant="body2"
                  >
                    dans le Fenua pour récolter des ressources et recharger votre mana.
                  </Typography>
                </Box>
              </Grid>
              <Grid item>
                <Box>
                  <Typography
                    color="primary"
                    component="h3"
                    variant="h4"
                  >
                    Plantez des arbres
                  </Typography>
                  <Typography
                    component="p"
                    variant="body2"
                  >
                    et créez des réseaux d’irrigation pour développer votre écosystème.
                  </Typography>
                </Box>
                <Typography
                  component="h3"
                  variant="h3"
                />
              </Grid>
              <Grid item>
                <Box>
                  <Typography
                    color="primary"
                    component="h3"
                    variant="h4"
                  >
                    Entretenez vos arbres
                  </Typography>
                  <Typography
                    component="p"
                    variant="body2"
                  >
                    et faites les évoluer pour qu’ils aient encore plus d’impact.
                  </Typography>
                </Box>

                <Typography
                  component="h3"
                  variant="h3"
                />
              </Grid>
            </Grid>
   
          </Paper>
        </Grid>

      </Grid>
    </>
  );
}

export default Preface;
